import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState = {
  addresses: [] as string[],
  successInfoConnect: false,
  isLoadingCheck: false,
  isLoadingChange: false,
  isSuccessChange: false,
}
const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setAddresses(state, { payload }: PayloadAction<string[]>) {
      state.addresses = payload
    },
    setSuccessInfoConnect(state, { payload }: PayloadAction<boolean>) {
      state.successInfoConnect = payload
    },
    setIsLoadingCheck(state, { payload }: PayloadAction<boolean>) {
      state.isLoadingCheck = payload
    },
    setIsLoadingChange(state, { payload }: PayloadAction<boolean>) {
      state.isLoadingChange = payload
    },
    setIsSuccessChange(state, { payload }: PayloadAction<boolean>) {
      state.isSuccessChange = payload
    },
    resetAddress: () => initialState,
  },
})
export type AddressStateType = typeof initialState
export const {
  setAddresses,
  setSuccessInfoConnect,
  setIsLoadingCheck,
  setIsLoadingChange,
  setIsSuccessChange,
  resetAddress,
} = addressSlice.actions
export const addressReducer = addressSlice.reducer
